export const locale = {
    lang: 'de',
    data: {
      'CONFIGURACION': {
        'CABECERA':{
          'TITULO': 'EINSTELLUNGEN',
          'DESCRIP': ''
        },
        'BOTONES':{
          'BOT1':{
            'TITULO': 'Upload collaborators database',
            'BOTON': 'Setzen'
          },
          'BOT2':{
            'TITULO': 'Firmenlogo hochladen',
            'BOTON': 'Setzen'
          },
          'BOT3':{
            'TITULO': 'Informationen zu technischen Anforderungen',
            'BOTON': 'Mehr sehen'
          }
        },
        'BD':{
          'TITUHEAD': 'Upload collaborators database',
          'INFO': 'Laden Sie die Mitarbeiterdatenbank Ihres Unternehmens in das System hoch',
          'BOTONES':{
            'DescTemp': 'Vorlage herunterladen'
          },
          'MENSAJES':{
            'CARGABD': 'BD hochladen',
            'STATUS': 'STATUS',
            'CORRECTO': 'Die Datenbank wurde erfolgreich hochgeladen',
            'ERROR': 'Beim Hochladen ist ein Fehler aufgetreten'
          }
        },
        'LOGO':{
          'TITUHEAD': 'Firmenlogo hochladen',
          'INFO': 'Laden Sie Ihr Firmenlogo-Bild hoch',
          'MENSAJES':{
            'CARGABD': 'Logo-Bild hochladen',
            'STATUS': 'STATUS',
            'CORRECTO': 'Das Logo wurde erfolgreich hochgeladen',
            'ERROR': 'Beim Hochladen ist ein Fehler aufgetreten'
          }
        },
        'REQTEC':{
          'TITUHEAD': 'Informationen zu technischen Anforderungen',
          'INFO': 'Plattformanforderungen zur Sicherstellung der optimalen Funktionalität',
          'MENSAJES':{
            'CARGA': '',
            'STATUS': 'STATUS',
            'CORRECTO': 'Hochgeladen erfolgreich',
            'ERROR': 'Beim Hochladen ist ein Fehler aufgetreten'
          }
        }
      }
    }
};
